import React from "react";
import "../Why/Why.css";
import { Link } from "react-router-dom";
import {
  FaBoxOpen,
  FaUserCheck,
  FaCheckCircle,
  FaThumbsUp,
  FaHeadset,
  FaLeaf,
} from "react-icons/fa";

const WhyChooseUs = () => {
  const stats = [
    { icon: <FaBoxOpen />, value: "23", label: "Years of Expertise" },
    { icon: <FaUserCheck />, value: "5.8+", label: "Customer Satisfaction" },
    { icon: <FaCheckCircle />, value: "6.1+", label: "Projects Completed" },
  ];

  const features = [
    { icon: <FaThumbsUp />, title: "Premium Quality" },
    { icon: <FaHeadset />, title: "24/7 Support" },
    { icon: <FaLeaf />, title: "Eco Friendly" },
  ];

  return (
    <section className="why-choose-us">
      <div className="stats-section">
        {stats.map((item, index) => (
          <div className="stat-box" key={index}>
            <div className="icon">{item.icon}</div>
            <h2>{item.value}</h2>
            <p>{item.label}</p>
          </div>
        ))}
      </div>

      <div className="divider" />

      <div className="content-section">
        <div className="left-text">
          <h2>
            <span>Why</span> Choose Us
          </h2>
          <p>
            At OrthoPack Solutions, we specialize in innovative and sterile
            packaging for orthopedic instruments. Our commitment to safety,
            precision, and sustainability ensures your medical devices are
            protected with the highest standards.
          </p>
          <Link to="/contactus">
            <button className="learn-more">
              <span>Contact Us</span>
            </button>
          </Link>
        </div>

        <div className="center-image">
          <img src="/ortho.webp" alt="Orthopedic Packaging" />
        </div>

        <div className="right-bars">
          {features.map((feature, index) => (
            <div
              className={`feature-bar ${feature.title === "Eco Friendly" ? "highlight" : ""}`}
              key={index}
            >
              <div className="feature-icon">{feature.icon}</div>
              <div className="feature-text">
                <h4>{feature.title}</h4>
                <p>Trusted by healthcare professionals.</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
